// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-chat-dialog__menu {
    border: 1px solid;
    width: 35rem;
    height: 20rem;
    transform: translate(6rem, -21rem) !important;
    text-align: center;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2px 7px 1px rgb(0 0 0 / 75%);
    border-radius: 5px;
    position: absolute !important;
    top: -5rem !important;
    left: 0rem !important;
    z-index: 10;
}

.close-chat-dialog__title {
    padding-top: 0.5rem;
}

.close-chat-dialog__select {
    display: block;
    width: 99%;
    margin-left: auto;
    margin-right: auto;
}

    .close-chat-dialog__select:focus-visible {
        outline-color: -webkit-focus-ring-color;
        outline-style: auto;
        outline-width: 1px;
    }

.close-chat-dialog__action-btn {
    height: 2.7rem;
    font-size: 0.9rem;
    box-shadow: none;
    border-radius: 0;
    margin: auto auto 0.5rem auto;
    line-height: 0;
}

.close-chat-dialog__footer {
    width: 100%;
    position: absolute;
    bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/chat/close-chat-dialog/CloseChatDialog.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;IAClB,oCAAoC;IACpC,4CAA4C;IAC5C,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;IAEI;QACI,uCAAuC;QACvC,mBAAmB;QACnB,kBAAkB;IACtB;;AAEJ;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".close-chat-dialog__menu {\r\n    border: 1px solid;\r\n    width: 35rem;\r\n    height: 20rem;\r\n    transform: translate(6rem, -21rem) !important;\r\n    text-align: center;\r\n    background-color: rgb(255, 255, 255);\r\n    box-shadow: 0px 2px 7px 1px rgb(0 0 0 / 75%);\r\n    border-radius: 5px;\r\n    position: absolute !important;\r\n    top: -5rem !important;\r\n    left: 0rem !important;\r\n    z-index: 10;\r\n}\r\n\r\n.close-chat-dialog__title {\r\n    padding-top: 0.5rem;\r\n}\r\n\r\n.close-chat-dialog__select {\r\n    display: block;\r\n    width: 99%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n    .close-chat-dialog__select:focus-visible {\r\n        outline-color: -webkit-focus-ring-color;\r\n        outline-style: auto;\r\n        outline-width: 1px;\r\n    }\r\n\r\n.close-chat-dialog__action-btn {\r\n    height: 2.7rem;\r\n    font-size: 0.9rem;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    margin: auto auto 0.5rem auto;\r\n    line-height: 0;\r\n}\r\n\r\n.close-chat-dialog__footer {\r\n    width: 100%;\r\n    position: absolute;\r\n    bottom: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
